import { create } from "zustand";
import type { AlertType, AlertFrequency } from "../types";

type AlertsFilterState = {
  searchValue: string | null;
  alertTypeFilter: AlertType | null;
  frequencyFilter: AlertFrequency | null;
  setSearchValue: (value: string | null) => void;
  setAlertTypeFilter: (alertType: AlertType | null) => void;
  setFrequencyFilter: (frequency: AlertFrequency | null) => void;
};

export const useAlertsFilterStore = create<AlertsFilterState>((set) => ({
  searchValue: null,
  alertTypeFilter: null,
  frequencyFilter: null,
  setSearchValue: (searchValue) => set({ searchValue }),
  setAlertTypeFilter: (alertTypeFilter) => set({ alertTypeFilter }),
  setFrequencyFilter: (frequencyFilter) => set({ frequencyFilter }),
}));
